import {
  POST_GRP_BIRTH_DETAILS,
  POST_GRP_BIRTH_DETAILS_SUCCESS,
  POST_GRP_BIRTH_DETAILS_FAIL,
  GET_ALL_REPORTS,
  GET_ALL_REPORTS_SUCCESS,
  GET_ALL_REPORTS_FAIL,
  GET_REPORT,
  GET_REPORT_SUCCESS,
  GET_REPORT_FAIL,
  GET_ALL_REPORTS_FOR_GROUP_ADMIN,
  GET_ALL_REPORTS_FOR_GROUP_ADMIN_SUCCESS,
  GET_ALL_REPORTS_FOR_GROUP_ADMIN_FAIL,
  GET_BRANCHES,
  GET_BRANCHES_SUCCESS,
  GET_BRANCHES_FAIL,
  GET_GROUP_USERS,
  GET_GROUP_USERS_SUCCESS,
  GET_GROUP_USERS_FAIL,
  GET_GROUP_MASTERS,
  GET_GROUP_MASTERS_SUCCESS,
  GET_GROUP_MASTERS_FAIL,
} from "./actionTypes"

export const postGRPBirthDetails = (birthDetail, history) => ({
  type: POST_GRP_BIRTH_DETAILS,
  payload: { birthDetail, history },
})

export const postGRPBirthDetailsSuccess = birthDetail => ({
  type: POST_GRP_BIRTH_DETAILS_SUCCESS,
  payload: birthDetail,
})

export const postGRPBirthDetailsFail = error => ({
  type: POST_GRP_BIRTH_DETAILS_FAIL,
  payload: error,
})

// Group 
export const getAllReports = (page, size, sortOrder, reportCreatedDate, name, refferedBy, city, mobile) => ({
  type: GET_ALL_REPORTS,
  payload: { page, size, sortOrder, reportCreatedDate, name, refferedBy, city, mobile }
})

export const getAllReportsSuccess = birthChartListPage => ({
  type: GET_ALL_REPORTS_SUCCESS,
  payload: birthChartListPage
})

export const getAllReportsFail = error => ({
  type: GET_ALL_REPORTS_FAIL,
  payload: error
})

export const getAllReportsForGroupAdmin = (page, size, sortOrder, reportCreatedDate, name, refferedBy, city, mobile, branchId, groupUserId) => ({
  type: GET_ALL_REPORTS_FOR_GROUP_ADMIN,
  payload: { page, size, sortOrder, reportCreatedDate, name, refferedBy, city, mobile, branchId, groupUserId }
})

export const getAllReportsForGroupAdminSuccess = birthChartListPage => ({
  type: GET_ALL_REPORTS_FOR_GROUP_ADMIN_SUCCESS,
  payload: birthChartListPage
})

export const getAllReportsForGroupAdminFail = error => ({
  type: GET_ALL_REPORTS_FOR_GROUP_ADMIN_FAIL,
  payload: error
})

export const getBranches = groupMastersId => ({
  type: GET_BRANCHES,
  groupMastersId
})

export const getBranchesSuccess = branches => ({
  type: GET_BRANCHES_SUCCESS,
  payload: branches,
})

export const getBranchesFail = error => ({
  type: GET_BRANCHES_FAIL,
  payload: error
})

export const getGroupUsers = (branchId, userType) => ({
  type: GET_GROUP_USERS,
  payload: { branchId, userType },
})

export const getGroupUsersSuccess = gropUserNames => ({
  type: GET_GROUP_USERS_SUCCESS,
  payload: gropUserNames,
})

export const getGroupUsersFail = error => ({
  type: GET_GROUP_USERS_FAIL,
  payload: error
})

export const getReport = reportId => ({
  type: GET_REPORT,
  reportId,
})

export const getReportSuccess = birthChart => ({
  type: GET_REPORT_SUCCESS,
  payload: birthChart,
})

export const getReportFail = error => ({
  type: GET_REPORT_FAIL,
  payload: error
})

export const getGroupMasters = () => ({
  type: GET_GROUP_MASTERS
})

export const getGroupMastersSuccess = groupMasters => ({
  type: GET_GROUP_MASTERS_SUCCESS,
  payload: groupMasters,
})

export const getGroupMastersFail = error => ({
  type: GET_GROUP_MASTERS_FAIL,
  payload: error
})